import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { useAdminRoutes } from '@shared/lib/routes'

interface TutorDetailHeaderOptions {
  text: string
}

interface TutorDetailHeaderReturn {
  config: ComputedRef<LinkBreadcrumbItem[]>
}

export const useTutorDetailHeader = ({ text }: TutorDetailHeaderOptions): TutorDetailHeaderReturn => {
  const route = useRoute()

  // Built inside computed so the breadcrumbs follow route.params.id when the
  // component instance is reused across different tutors.
  const config = computed<LinkBreadcrumbItem[]>(() => {
    const tutorId = route.params.id as string

    const tutorsUrl = useAdminRoutes('admin.tutors.index') ?? ''
    const tutorUrl = useAdminRoutes('admin.tutor.show', { tutor_id: tutorId }) ?? ''

    return [
      {
        id: 'tutors',
        text: 'Tutors',
        to: tutorsUrl,
        disabled: false,
      },
      {
        id: 'tutor-detail',
        text: `Tutor / ${tutorId}`,
        to: tutorUrl,
        disabled: false,
      },
      {
        id: 'current-page',
        text,
        to: null,
        disabled: true,
      },
    ]
  })

  return {
    config,
  }
}
